import { ErrorReporter, loadScript } from '~/utils'
import { authState } from './state'

export function isLoggedIntoFb(): Promise<boolean> {
  return new Promise<boolean>((resolve) => {
    try {
      FB.getLoginStatus((response: fb.StatusResponse) => {
        if (response.status === 'connected') {
          authState.token = response.authResponse.accessToken || ''
          resolve(true)
        } else {
          resolve(false)
        }
      })
    } catch (error) {
      ErrorReporter.exception(error as Error)
      resolve(false)
    }
  })
}

export function loadFb(
  fbAppId: string,
  language: string,
  callback: () => void = () => {
    /* */
  }
): Promise<boolean> {
  const element = 'facebook-jssdk'
  const url = `https://connect.facebook.net/${
    language === 'hu' ? 'hu_HU' : 'en_US'
  }/sdk.js`

  return new Promise<boolean>((resolve) => {
    if (document.getElementById(element)) {
      // facebook script is already on the page
      resolve(true)
      return
    }
    // setting  up callbacks
    ;(window as any).fbAsyncInit = () => {
      FB.init({ appId: fbAppId, cookie: true, xfbml: true, version: 'v2.7' })
      resolve(true)
    }
    ;(window as any).fbLoginBtnCallback = callback

    // adding the script to the document
    loadScript(url, element)
      .then()
      .catch((error) => {
        ErrorReporter.exception(error)
        resolve(false)
      })
  })
}
